import React from 'react';
import { Link } from 'react-router-dom';

export const CareersPage = () => {
  return (
    <div className="py-10" data-testid="careers-page">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Join Our Team</h1>
        <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
          We're always looking for experienced, professional drivers to join our growing team.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-8 rounded-lg shadow-lg" data-testid="career-card">
            <h2 className="text-2xl font-bold mb-4">Company Driver</h2>
            <p className="text-gray-600 mb-6">
              Join our team as a company driver and enjoy competitive pay, excellent benefits, and a supportive work environment.
            </p>
            <h3 className="font-bold mb-3">Benefits:</h3>
            <ul className="space-y-2 text-gray-600 mb-6">
              <li>✓ Competitive hourly/daily pay</li>
              <li>✓ Health insurance</li>
              <li>✓ Paid time off</li>
              <li>✓ Modern equipment</li>
              <li>✓ Local routes - home daily</li>
            </ul>
            <Link to="/apply/company-driver" className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition font-medium inline-block" data-testid="apply-company-driver-btn">
              Apply Now
            </Link>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg" data-testid="career-card">
            <h2 className="text-2xl font-bold mb-4">Owner Operator</h2>
            <p className="text-gray-600 mb-6">
              Partner with us and grow your business with consistent work and competitive rates.
            </p>
            <h3 className="font-bold mb-3">Benefits:</h3>
            <ul className="space-y-2 text-gray-600 mb-6">
              <li>✓ Competitive percentage rates</li>
              <li>✓ Consistent work</li>
              <li>✓ Fuel card program</li>
              <li>✓ Quick payment terms</li>
              <li>✓ 24/7 dispatch support</li>
            </ul>
            <Link to="/apply/owner-operator" className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition font-medium inline-block" data-testid="apply-owner-operator-btn">
              Apply Now
            </Link>
          </div>
        </div>

        <div className="bg-gray-50 p-8 rounded-lg">
          <h2 className="text-2xl font-bold mb-4 text-center">Requirements</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-bold mb-3">For All Drivers:</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Valid Class A CDL</li>
                <li>• Clean driving record</li>
                <li>• Minimum 2 years experience</li>
                <li>• Pass DOT physical & drug screening</li>
                <li>• TWIC card (preferred)</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold mb-3">For Owner Operators:</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Own authority or willing to lease</li>
                <li>• Current insurance documentation</li>
                <li>• Well-maintained tractor</li>
                <li>• Available for local/regional runs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareersPage;